export default "__VITE_ASSET__BXT$mfRM__"